import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a286b116"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "school-year" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "school-year-unit" }, "年度", -1))
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EditableItemNumber = _resolveComponent("EditableItemNumber")!

  return (_openBlock(), _createElementBlock("div", {
    class: "school-year-switch-container",
    "data-testid": "school-year-switch",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["button prev-button", { enabled: _ctx.enabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toPrevYear && _ctx.toPrevYear(...args))),
      disabled: !_ctx.enabled
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "icon",
        icon: ['fas', 'chevron-left']
      })
    ], 10, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EditableItemNumber, {
        class: "school-year-value",
        value: _ctx.schoolYear,
        "default-value": _ctx.currentSchoolYear,
        editable: _ctx.enabled,
        "font-size": _ctx.numberFontSize,
        "on-input": _ctx.onChangeInternal,
        "on-blur": _ctx.onBlur,
        "on-enter": _ctx.onEnter,
        "select-on-focus": true
      }, null, 8, ["value", "default-value", "editable", "font-size", "on-input", "on-blur", "on-enter"]),
      _hoisted_3
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["button next-button", { enabled: _ctx.enabled }]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toNextYear && _ctx.toNextYear(...args))),
      disabled: !_ctx.enabled
    }, [
      _createVNode(_component_font_awesome_icon, {
        class: "icon",
        icon: ['fas', 'chevron-right']
      })
    ], 10, _hoisted_4)
  ], 4))
}